// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://ynbdental-backend.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://ynbdental-backend.onrender.com/";
export const Homeurl = "https://ynbdental.com/";
export const adminurl = "https://admin.ynbdental.com/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://test.payu.in/_payment';
export const socketURL = "https://ynbdental-backend.onrender.com/";


// export const weburl = 'https://hospitalquee.onrender.com/';
